import React from 'react';
import { Col, Grid, Row, Typography } from 'antd';
import classNames from 'classnames';

import ImageC from 'src/components/Image';

import classes from './index.module.less';

type Props = {
	title: string;
	description: string;
	image: string;
	height?: string;
};

const Hero = (props: Props) => {
	const { md, xl } = Grid.useBreakpoint();

	return (
		<div className={classNames('bg-white', classes['absolute-background'])}>
			<div className={classes.bghero} style={{ height: props.height }}>
				<Row>
					<Col xs={24} md={15}>
						<div className={classNames('pt-xl-4', classes.hero)} style={{ height: props.height }}>
							<Row>
								<Col md={2} xl={5}></Col>
								<Col xs={24} md={18} xl={17}>
									<div className="container py-3 py-md-5">
										<Typography.Title level={1} className={classes.title}>
											<span
												dangerouslySetInnerHTML={{
													__html: props.title,
												}}
											/>
										</Typography.Title>
										<Typography.Paragraph className={classes.description}>
											{props.description}
										</Typography.Paragraph>
									</div>
								</Col>
								<Col md={2}></Col>
							</Row>
						</div>
					</Col>
					{md && (
						<Col xs={24} md={9}>
							<div className="text-right">
								<ImageC
									objectFit="contain"
									width={xl ? 630 : md ? 400 : 320}
									height={xl ? 630 : md ? 400 : 320}
									src={props.image}
								/>
							</div>
						</Col>
					)}
				</Row>
			</div>
		</div>
	);
};

export default Hero;
